export const squiggle = function(ctx: any) {
  ctx.save();
  ctx.strokeStyle = "rgba(0,0,0,0)";
  ctx.miterLimit = 4;
  ctx.save();
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(136.01, 147);
  ctx.bezierCurveTo(135.51, 147, 134.98999999999998, 146.96, 134.48, 146.87);
  ctx.bezierCurveTo(
    129.57999999999998,
    146.03,
    126.28999999999999,
    141.38,
    127.13,
    136.48000000000002
  );
  ctx.bezierCurveTo(
    132.43,
    105.50000000000001,
    128.62,
    84.10000000000002,
    115.81,
    72.85000000000002
  );
  ctx.bezierCurveTo(
    95.88,
    55.36000000000003,
    59.050000000000004,
    66.48000000000002,
    58.68,
    66.59000000000002
  );
  ctx.bezierCurveTo(
    53.93,
    68.06000000000002,
    48.89,
    65.41000000000001,
    47.42,
    60.670000000000016
  );
  ctx.bezierCurveTo(
    45.95,
    55.93000000000002,
    48.58,
    50.890000000000015,
    53.32,
    49.41000000000002
  );
  ctx.bezierCurveTo(
    55.22,
    48.820000000000014,
    100.05,
    35.16000000000002,
    127.62,
    59.26000000000002
  );
  ctx.bezierCurveTo(
    145.51,
    74.90000000000002,
    151.32,
    101.90000000000002,
    144.88,
    139.51000000000002
  );
  ctx.bezierCurveTo(144.12, 143.9, 140.31, 147, 136.01, 147);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
  ctx.restore();
};
